import React from "react";
import PropTypes from "prop-types";
import { IconButton, Tooltip } from "@mui/material";
import TextsmsOutlinedIcon from "@mui/icons-material/TextsmsOutlined";

export const FeedbackButton = ({ onClick }) => {
  return (
    <Tooltip title="Share feedback">
      <IconButton
        color="primary"
        onClick={onClick}
        size="small"
        aria-label="Open feedback form"
      >
        <TextsmsOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

FeedbackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
